export default "__VITE_ASSET__CTwpCiHf__"